import { error, finish } from '../../../modules/market-templates/actions/update-selection';

export function request(dispatch, { id, sportId, eventTemplateId, marketTemplateId, data }) {

    $appState.sdkStaff.patchMarketTemplateSelections({
        requestBody: {
            marketTemplateId,
            eventTemplateId,
            selectionId: id,
            sportId,
            data
        }
    }).then(
        selectionTemplate => dispatch(finish(id, marketTemplateId, selectionTemplate)),
        errors => dispatch(error(id, marketTemplateId, errors))
    );
}
